import UserAvatar from '@/components/UserAvatar';
import { type User } from '@/lib/types';
import styled from '@emotion/styled';
import {
  ListItem,
  ListItemAvatar,
  type ListItemProps,
  ListItemText,
} from '@mui/material';

// eslint-disable-next-line react-refresh/only-export-components
export const UserAutocompleteListItem = styled(ListItem)({
  paddingTop: 0,
  paddingBottom: 0,
  '> .MuiListItemAvatar-root': {
    width: 44,
    minWidth: 44,
  },
});

type UserAutocompleteOptionProps = Omit<ListItemProps, 'dense' | 'children'> & {
  user: User;
};

const UserAutocompleteOption = ({
  user,
  ...props
}: UserAutocompleteOptionProps) => (
  <UserAutocompleteListItem dense {...props}>
    <ListItemAvatar>
      <UserAvatar user={user} size={32} />
    </ListItemAvatar>
    <ListItemText primary={user.name} secondary={user.email} />
  </UserAutocompleteListItem>
);

export default UserAutocompleteOption;
